import React, { useEffect, useState, useRef } from 'react';
import { TestimonialCard, TestimonialCardProps } from './TestimonialCard';
interface TestimonialCarouselProps {
  testimonials: TestimonialCardProps[];
}
export function TestimonialCarousel({
  testimonials
}: TestimonialCarouselProps) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);
  // Determine if mobile view (1 card) or desktop (3 cards)
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  const cardsToShow = isMobile ? 1 : 3;
  const maxIndex = Math.max(0, testimonials.length - cardsToShow);
  // Auto-slide
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prev => prev >= maxIndex ? 0 : prev + 1);
    }, 4000);
    return () => clearInterval(timer);
  }, [maxIndex]);
  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
  };
  const handleTouchMove = (e: React.TouchEvent) => {
    touchEndX.current = e.touches[0].clientX;
  };
  const handleTouchEnd = () => {
    if (touchStartX.current - touchEndX.current > 50) {
      // Swipe left (next)
      setCurrentIndex(prev => Math.min(prev + 1, maxIndex));
    }
    if (touchStartX.current - touchEndX.current < -50) {
      // Swipe right (prev)
      setCurrentIndex(prev => Math.max(prev - 1, 0));
    }
  };
  return <div className="relative w-full overflow-hidden py-4" data-id="element-78">
      <div className="flex transition-transform duration-500 ease-out" style={{
      transform: `translateX(-${currentIndex * (100 / cardsToShow)}%)`
    }} onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} data-id="element-79">
        {testimonials.map((testimonial, idx) => <div key={idx} className="w-full md:w-1/3 flex-shrink-0 px-3" data-id="element-80">
            <TestimonialCard {...testimonial} data-id="element-81" />
          </div>)}
      </div>

      {/* Dots */}
      <div className="flex justify-center mt-8 space-x-2" data-id="element-82">
        {Array.from({
        length: maxIndex + 1
      }).map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-2 h-2 rounded-full transition-all duration-300 ${currentIndex === idx ? 'bg-rosegold w-6' : 'bg-white/20 hover:bg-white/40'}`} aria-label={`Go to slide ${idx + 1}`} data-id="element-83" />)}
      </div>
    </div>;
}